/**
 * Dependencies
 */
import { cloneDeep } from 'lodash'

const base = {
    loading: false,
    summary: {
        data: [],
        meta: {
            index: []
        }
    },
    proForma: {
        data: [],
        meta: {
            index: []
        }
    },
    schedule: {
        data: [],
        meta: {
            index: []
        }
    },
    meta: {}
}

/**
 * Return a fresh copy of the base state
 *
 * @return {Object}
 */
export const getState = () => cloneDeep(base)

export default getState()



// WEBPACK FOOTER //
// ./src/state/modules/projects/single/rent-roll/state.js